import { formatDataSource, formatGeoLabel } from '../lib/breadcrumbFormat';
import type { Breadcrumb } from '../types';

const toItems = ({ geo, dataSource, typeLabel }: Breadcrumb): string[] =>
    [formatGeoLabel(geo), formatDataSource(dataSource), typeLabel].filter(
        Boolean,
    ) as string[];

/**
 * The breadcrumb string itself — `geo · dataSource · typeLabel` — with no
 * surrounding chrome. Frames drop this between their own decorations: the purple
 * bar (assistant / report-view) or the grip + actions menu (report-edit). Renders
 * nothing when there's nothing to show.
 */
export const BreadcrumbItems = (breadcrumb: Breadcrumb) => {
    const items = toItems(breadcrumb);
    if (items.length === 0) return null;
    return (
        <div className="flex items-center gap-2 min-w-0">
            {items.map((item, i) => (
                <span key={`${item}-${i}`} className="contents">
                    {i > 0 && (
                        <span className="text-muted-foreground/40 text-xs">
                            ·
                        </span>
                    )}
                    <span className="text-xs font-medium text-muted-foreground">
                        {item}
                    </span>
                </span>
            ))}
        </div>
    );
};

/**
 * Default breadcrumb header: the items behind a 2px primary vertical bar. Used by
 * the assistant frame and by the report frame's view mode.
 */
const InlineCardBreadcrumb = (breadcrumb: Breadcrumb) => {
    if (toItems(breadcrumb).length === 0) return null;
    return (
        <div className="flex items-center pl-2.5 border-l-2 border-primary">
            <BreadcrumbItems {...breadcrumb} />
        </div>
    );
};

export default InlineCardBreadcrumb;
